/**
 * User / Shop Helpers
 *
 * Pure stateless utilities for user-specific display values.
 * These accept the user object as a parameter instead of accessing `this.user`
 * from the mixin, making them testable and tree-shakeable.
 *
 * Migrated from: src/mixins/global.js
 */
import { isLive, isEuServer } from './env.helpers'

interface UserShopData {
  referallshopName?: string
  shopLogo?: string
}

const FALLBACK_LOGO = require('@/resources/images/messaging-commerce-grey-with-padding.jpg')

/**
 * Returns the shop logo URL, falling back to the default logo if none is set.
 */
export function getShopLogoImage(user: UserShopData | undefined | null): string {
  if (user?.shopLogo && user.shopLogo !== '' && user.shopLogo !== 'None') {
    return user.shopLogo
  }
  return FALLBACK_LOGO
}

/**
 * Constructs the public shop URL considering the deployment environment
 * and whether a custom domain is configured.
 */
export function shopLinkConsideringCustomDomain(user: UserShopData | undefined | null): string {
  if (!user?.referallshopName) return ''
  if (isLive()) {
    if (isEuServer()) return `https://${user.referallshopName}.jumper-emea.com`
    return `https://${user.referallshopName}.jumper.ai`
  }
  return `https://${user.referallshopName}.jumperdev.com`
}

/**
 * Returns the base host for the agent livechat (talktous) link.
 * Uses the dedicated `shop.{domain}` subdomain — NOT the store subdomain.
 *
 * Format: https://shop.{domain}/talktous/<storename>/<hash-id>/wa/<agent-nickname>
 */
export function shopLivechatBase(): string {
  if (isLive()) {
    if (isEuServer()) return 'https://shop.jumper-emea.com'
    return 'https://shop.jumper.ai'
  }
  return 'https://shop.jumperdev.com'
}
